// ─────────────────────────────────────────────────────────────
//  LEASEIN — conținut editabil
//  Modifică textele de aici fără să umbli prin componente.
// ─────────────────────────────────────────────────────────────

export const contact = {
  email: "office@leasein.ro",
  phones: [
    { display: "0727 765 362", href: "+40727765362" },
    { display: "0746 666 676", href: "+40746666676" },
  ],
  // Cheia Web3Forms — trimite solicitările pe email.
  web3formsKey: "07678c25-10b5-4c58-af83-1b46f0c4987e",
};

export const hero = {
  kicker: "Leasing operațional auto",
  title: ["Mobilitate pentru afacerea ta,", "fără bătăi de cap."],
  subtitle:
    "Rate lunare fixe care includ totul — service, asigurări, anvelope și taxe. Tu te ocupi de business, noi de mașini.",
  badges: [
    { strong: "Avans 0", label: "la majoritatea contractelor" },
    { strong: "Servicii complete", label: "incluse în rată" },
    { strong: "Cost fix", label: "predictibil lunar" },
  ],
};

export const advantages = [
  {
    title: "Costuri previzibile, fără surprize",
    op: "Rată lunară fixă care include service, anvelope, asigurări și taxe. Știi exact cât plătești în fiecare lună.",
    fin: "Pe lângă rată, plătești separat asigurări, mentenanță, anvelope și reparații neprevăzute.",
  },
  {
    title: "Fără avans, fără imobilizare de capital",
    op: "Pornești de obicei cu avans 0 și păstrezi banii companiei pentru activitatea de bază.",
    fin: "Necesită avans semnificativ și blochează capital care ar putea lucra în afacere.",
  },
  {
    title: "Mașina nu îți apare în bilanț",
    op: "Plățile sunt tratate ca o cheltuială operațională, complet deductibilă, fără active de gestionat.",
    fin: "Vehiculul intră în patrimoniu ca activ și trebuie amortizat în timp.",
  },
  {
    title: "Zero grija valorii reziduale",
    op: "La final returnezi mașina. Riscul de revânzare și deprecierea sunt problema noastră, nu a ta.",
    fin: "Rămâi cu mașina și cu riscul ca valoarea ei să scadă mult până o vinzi.",
  },
  {
    title: "Flotă mereu nouă",
    op: "La final de contract treci pe un model nou. Angajații conduc mereu mașini recente și sigure.",
    fin: "Mașina îmbătrânește odată cu tine și costurile de întreținere cresc an de an.",
  },
  {
    title: "Un singur partener, un singur cost",
    op: "Gestionăm noi tot: înmatriculare, RCA, CASCO, ITP, service, anvelope de sezon, mașină de înlocuire.",
    fin: "Coordonezi singur relațiile cu service-ul, asigurătorul și restul furnizorilor.",
  },
];

export const about = {
  title: "Un singur partener pentru toată mobilitatea companiei tale",
  paragraphs: [
    "LEASEIN oferă soluții de leasing operațional gândite pentru firme care vor o flotă eficientă, fără să-și consume timpul cu administrarea ei. De la achiziție și înmatriculare până la service, asigurări și returnare — ne ocupăm de tot.",
    "Lucrăm transparent, cu costuri fixe și fără surprize, ca tu să te poți concentra pe ceea ce contează: afacerea ta.",
  ],
  stats: [
    { value: "0", label: "avans, la majoritatea contractelor" },
    { value: "1 cost", label: "fix, lunar, complet" },
    { value: "100%", label: "servicii incluse" },
  ],
};

export const trust = [
  "Ofertă personalizată la cerere",
  "Contracte flexibile, pe nevoile tale",
  "Suport dedicat pe toată durata contractului",
];
